<template>
  <div class="video-wrap">
    <div class="search-group">
      <el-select clearable class="search-item" v-model="filterData.isBind" filterable placeholder="自动绑定开关状态" @change="searchData">
        <el-option label="关" :value="false"></el-option>
        <el-option label="开" :value="true"></el-option>
      </el-select>
      <el-select class="search-item" multiple clearable v-model="filterData.authIds" filterable collapse-tags placeholder="选择授权人" @change="searchData">
        <el-option v-for="item in authorizerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-input
        clearable
        class="search-item"
        placeholder="请输入媒体账户"
        v-model="filterData.email"
        suffix-icon="el-icon-search"
        @input="searchData"
      ></el-input>
      <el-date-picker
        class="search-item"
        style="position: relative; top: -2px"
        v-model="filterData.formdate"
        type="daterange"
        @change="searchData"
        align="right"
        size="small"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      ></el-date-picker>
    </div>
    <div class="table-group">
      <el-table :data="tableData" ref="account" height="calc(100vh - 276px)" style="width: 100%">
        <el-table-column prop="isBind" label="新账号自动绑定开关">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isBind" @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="媒体账户"> </el-table-column>
        <el-table-column prop="accountCount" label="已绑定账户数"> </el-table-column>
        <el-table-column prop="authName" label="授权人"> </el-table-column>
        <el-table-column prop="updateTime" label="最后授权时间"> </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.isBind || scope.row.accountCount > 0" content="只有绑定账户数为0且开关为关闭时方可删除" placement="top">
              <el-button type="text" size="small" style="color: #c0c4cc">删除</el-button>
            </el-tooltip>
            <el-button v-else type="text" size="small" @click="deleteAccount(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        @getCurrentPage="getCurrentPage"
        @handleSizeChange="changePageSize"
        ref="tabelPagination"
      ></self-pagination>
    </div>
  </div>
</template>

<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import { getMediaAccountList, updateMediaAccountStatus, deleteMediaAccount, getMediaAuthUsers } from "@/api/promotion-google";
import moment from "moment";

export default {
  data() {
    return {
      filterData: {
        isBind: "",
        authIds: [],
        email: "",
        formdate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
      },
      authorizerList: [],
      tableData: [],
      pageData: {
        size: 10,
        page: 1,
        total: 10,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
      },
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.searchData();
    this.initSelect();
  },

  methods: {
    searchData() {
      getMediaAccountList({
        platType: 5,
        startTime: moment(this.filterData.formdate[0]).format("yyyy-MM-DD") + " 00:00:00",
        endTime: moment(this.filterData.formdate[1]).format("yyyy-MM-DD") + " 23:59:59",
        pageNum: this.pageData.page,
        pageSize: this.pageData.pageSize,
        authIds: this.filterData.authIds.join(","),
        email: this.filterData.email,
        isBind: this.filterData.isBind,
      }).then((res) => {
        this.tableData = res.data.list;
        this.pageData.total = res.data.total;
      });
    },
    initSelect() {
      getMediaAuthUsers().then((res) => {
        this.authorizerList = res.data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getCurrentPage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    resetData() {
      this.filterData = {
        isBind: "",
        authIds: [],
        email: "",
        formdate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
      };
      this.getCurrentPage(1);
    },
    changeStatus(row) {
      updateMediaAccountStatus({
        isBind: row.isBind,
        id: row.id,
      }).then(() => {
        this.$message.success("修改成功");
      });
    },
    deleteAccount(row) {
      this.$confirm("确定删除该媒体账户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteMediaAccount({
            id: row.id,
          }).then((res) => {
            if (res.code === "0000") {
              this.$message.success("删除成功");
              this.resetData();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.video-wrap {
  .search-group {
    .search-item {
      width: 260px;
      margin-right: 16px;
    }
  }
  .table-group {
    margin-top: 16px;
  }
}
</style>
